import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { compose, defaultTo, descend, groupWith, head, last, path, prop, sortWith } from 'ramda';
import he from 'he';
import { Link } from 'react-router-dom';

import { routes } from '../../../../routes';

import Card from '../../../../components/Card';

const propTypes = {
  certifications: PropTypes.array,
};

const List = ({ certifications }) => {
  const grouped = compose(
    groupWith((a, b) => a.certificationId == b.certificationId),
    sortWith([descend(prop('certificationId')), descend(prop('reportingPeriodId'))]),
  )(certifications);

  return (
    <div>
      <div className="row">
        <div className="col">
          <Card>
            <Card.Header compact certification>
              Certifications
            </Card.Header>
            <Card.Body>
              {certifications.length ? (
                'Below are your certifications. Select one to view more information'
              ) : (
                <Fragment>
                  You don't have any certifications yet, but you can register for one{' '}
                  <Link to={routes.certificationsAndTraining.register.root}>here</Link>
                </Fragment>
              )}
            </Card.Body>
          </Card>
          <div className="row mt-4">
            <div className="col">
              <div className="card-deck">
                {grouped &&
                  grouped.map((userCertifications) => {
                    const certification = head(userCertifications);

                    return (
                      <Card key={certification.id} certification className="mb-4">
                        <Card.Header divider>{he.decode(certification.name)}</Card.Header>
                        <Card.Body>
                          <p>
                            <strong>Status:</strong> {certification.status}
                          </p>
                          {certification.accredibleUrl && (
                            <p>
                              <strong>Certificate:</strong> <a href={certification.accredibleUrl}>View</a>
                            </p>
                          )}
                        </Card.Body>
                        <Card.Action
                          as={Link}
                          to={routes.certificationsAndTraining.certifications.viewBuilder(
                            certification.certificationId,
                          )}
                        >
                          View Details
                        </Card.Action>
                      </Card>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

List.propTypes = propTypes;

export default List;
